import { render, staticRenderFns } from "./StoreObject.vue?vue&type=template&id=a0f6f66a"
import script from "./StoreObject.vue?vue&type=script&lang=js"
export * from "./StoreObject.vue?vue&type=script&lang=js"
import style0 from "./StoreObject.vue?vue&type=style&index=0&id=a0f6f66a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports